.publicCollectionConfirmationContentImg {
  margin: var(--base-unit-l) auto;
  display: block;
  max-width: 100%;
}
